import { Component, OnInit } from '@angular/core';
import { NguCarouselConfig } from '@ngu/carousel';
import { HomeService } from './home.service';
import { TarjetaHome } from 'src/app/shared/models/tarjeta-home.model';
import { TarjetaPasosHome } from 'src/app/shared/models/tarjeta-pasos-home.model';
import { FooterLinkModel } from 'src/app/shared/models/footer-link.model';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
	tarjetas: Array<TarjetaHome> = [];
	tarjetasPasos: Array<TarjetaPasosHome> = [];
	links: Array<FooterLinkModel> = [];

	public configCarouselTile: NguCarouselConfig = {
		grid: { xs: 1, sm: 1, md: 3, lg: 3, all: 0 },
		slide: 3,
		speed: 450,
		animation: 'lazy',
		easing: 'ease',
		loop: true,
		point: {
			visible: true
		},
		load: 2,
		touch: true
	};

	constructor(private homeService: HomeService) { }

	ngOnInit() {
		this.homeService.get(1).subscribe(resultado => {
			if (resultado.result) {
				this.tarjetas = resultado.data as Array<TarjetaHome>;
			}
		});

		this.homeService.get(2).subscribe(resultado => {
			if (resultado.result) {
				this.tarjetasPasos = resultado.data as Array<TarjetaPasosHome>;
			}
		});

		this.homeService.get(3).subscribe(resultado => {
			if (resultado.result) {
				this.links = resultado.data as Array<FooterLinkModel>;
			}
		});
	}

	onOpenWindow(url: string) {
		window.open(url);
	}
}
